const ANALYTICS_ENABLED = false;

const GTM_SCRIPT_ID = "gtm-container-script";
const GTAG_SCRIPT_ID = "gtag-script";
const STACKS = {
  default: {
    key: "default",
    gtmId: "GTM-5HR4Q7D",
    dataLayerName: "autoturDataLayer",
  },
  transfer: {
    key: "transfer",
    gtmId: "GTM-KJVXNCR",
    gaId: "G-8VZ3TMKPEZ",
    dataLayerName: "transferDataLayer",
    gtagFunctionName: "transferGtag",
  },
};

function getStackByPathname(pathname = "") {
  return pathname.startsWith("/transfer") ? STACKS.transfer : STACKS.default;
}

function ensureDataLayer(name) {
  if (!window[name]) {
    window[name] = [];
  }

  return window[name];
}

function removeNode(id) {
  document.getElementById(id)?.remove();
}

function loadGtm(stack) {
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  const dataLayer = ensureDataLayer(stack.dataLayerName);
  dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  const layerParam =
    stack.dataLayerName !== "dataLayer" ? `&l=${stack.dataLayerName}` : "";

  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${stack.gtmId}${layerParam}`;

  document.head.appendChild(script);
}

function loadGtag(stack) {
  if (!stack.gaId || document.getElementById(GTAG_SCRIPT_ID)) {
    return;
  }

  ensureDataLayer(stack.dataLayerName);

  const gtagFunctionName = stack.gtagFunctionName || "gtag";

  window[gtagFunctionName] = function gtag() {
    window[stack.dataLayerName].push(arguments);
  };

  window[gtagFunctionName]("js", new Date());
  window[gtagFunctionName]("config", stack.gaId, {
    send_page_view: false,
  });

  const script = document.createElement("script");
  script.id = GTAG_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${stack.gaId}&l=${stack.dataLayerName}`;

  document.head.appendChild(script);
}

function loadStack(stack) {
  loadGtm(stack);
  loadGtag(stack);
}

function clearLoadedStack() {
  removeNode(GTM_SCRIPT_ID);
  removeNode(GTAG_SCRIPT_ID);
}

export function syncAnalyticsStack(pathname) {
  if (!ANALYTICS_ENABLED) {
    return { stack: getStackByPathname(pathname), shouldTrackPageView: false };
  }
  const nextStack = getStackByPathname(pathname);
  const currentStackKey = window.__activeAnalyticsStack;

  if (!currentStackKey) {
    window.__activeAnalyticsStack = nextStack.key;
    loadStack(nextStack);
    return { stack: nextStack, shouldTrackPageView: true };
  }

  if (currentStackKey !== nextStack.key) {
    clearLoadedStack();
    window.__activeAnalyticsStack = nextStack.key;
    window.location.reload();
    return { stack: nextStack, shouldTrackPageView: false };
  }

  return { stack: nextStack, shouldTrackPageView: true };
}

export function trackPageView({
  pathname,
  search = "",
  title = document.title,
}) {
  if (!ANALYTICS_ENABLED) {
    return;
  }
  const stack = getStackByPathname(pathname);
  const location = `${window.location.origin}${pathname}${search}`;
  const dataLayer = ensureDataLayer(stack.dataLayerName);
  const pageData = {
    event: "page_view",
    page_path: `${pathname}${search}`,
    page_location: location,
    page_title: title,
    analytics_scope: stack.key,
  };

  dataLayer.push(pageData);

  if (stack.gaId && stack.gtagFunctionName && window[stack.gtagFunctionName]) {
    window[stack.gtagFunctionName]("event", "page_view", {
      page_path: pageData.page_path,
      page_location: pageData.page_location,
      page_title: pageData.page_title,
    });
  }
}

export function trackEvent(
  name,
  params = {},
  pathname = window.location.pathname,
) {
  if (!ANALYTICS_ENABLED) {
    return;
  }
  const stack = getStackByPathname(pathname);
  const dataLayer = ensureDataLayer(stack.dataLayerName);
  const payload = {
    event: name,
    analytics_scope: stack.key,
    ...params,
  };

  dataLayer.push(payload);

  if (stack.gaId && stack.gtagFunctionName && window[stack.gtagFunctionName]) {
    window[stack.gtagFunctionName]("event", name, params);
  }
}
